'use client'

import { Link } from '@/components/link'
import { Section } from '@/components/section'
import { cn } from '@/lib/utils'
import { ArrowLeftToLineIcon } from 'lucide-react'
import { useEffect, useState } from 'react'

type SafariConditionalSectionProps = {
  href: string
  text: string
  conditionalClasses: string
}

export const SafariConditionalSection = ({
  href,
  text,
  conditionalClasses,
}: SafariConditionalSectionProps) => {
  const [isSafari, setIsSafari] = useState(false)

  useEffect(() => {
    // More accurate Safari detection
    const userAgent = navigator.userAgent.toLowerCase()

    // Check for Safari-specific indicators
    const isWebkit = userAgent.indexOf('webkit') > -1
    const isChrome = userAgent.indexOf('chrome') > -1
    const isSafari = userAgent.indexOf('safari') > -1
    const isEdge =
      userAgent.indexOf('edge') > -1 || userAgent.indexOf('edg/') > -1
    const isFirefox = userAgent.indexOf('firefox') > -1

    // Safari is WebKit-based, has 'safari' in user agent, but is NOT Chrome, Edge, or Firefox
    const isSafariDetected =
      isWebkit && isSafari && !isChrome && !isEdge && !isFirefox

    setIsSafari(isSafariDetected)
  }, [])

  return (
    <Section
      className={cn(
        // Only apply these classes if NOT Safari
        !isSafari && conditionalClasses
      )}
      delay={0.6}
    >
      <Link
        href={href}
        className={cn(
          'flex items-center gap-2 text-nowrap text-foreground-lighter text-xs transition-colors',
          'hover:text-foreground'
        )}
      >
        <ArrowLeftToLineIcon size={12} />
        {text}
      </Link>
    </Section>
  )
}
